import ContractMigrationConsentsService from "@/api/services/contractMigrationConsents";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  consents: [],
};

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    setConsents(state, consents) {
      state.consents = consents;
    },

    updateConsentStatus(state, { id, status }) {
      const consent = state.consents.find((c) => c.id === id);
      if (consent) {
        consent.status = status;
      }
    },
  },

  getters: {
    pendingConsents(state) {
      return state.consents.filter((c) => c.status === "pending");
    },

    remainingDays() {
      return (consent) => {
        const createdAt = new Date(consent.createdAt);
        const deadline = new Date(createdAt);
        deadline.setDate(deadline.getDate() + 30);
        const now = new Date();
        const diffMs = deadline - now;
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return Math.max(0, diffDays);
      };
    },
  },

  actions: {
    async fetchConsents({ commit }) {
      const response = await ContractMigrationConsentsService.getConsents();
      if (response?.success) {
        const { records = [] } = response.data || {};
        commit("setConsents", toCamelCase(records));
      }
      return response;
    },

    async respondToConsent({ commit }, { id, status }) {
      const response = await ContractMigrationConsentsService.updateConsent(id, status);
      if (response?.success) {
        commit("updateConsentStatus", { id, status });
      }
      return response;
    },
  },
};
